export default __webpack_public_path__ + "static/media/221.7383ba9d.jpg";